interface Window {
    webkit: any;
    android: any;
}

declare const window: Window;

enum PLATFORM {
    ANDROID = 'android',
    IOS = 'ios',
    WEB = 'web',
}

const _canUseIOSMessage = () =>
    window.webkit !== undefined &&
    window.webkit.messageHandlers !== undefined &&
    window.webkit.messageHandlers.ffi !== undefined;

const _canUseAndroidMessage = () => window.android !== undefined;

const _getNativePlatform = () => {
    if (_canUseIOSMessage()) {
        return PLATFORM.IOS;
    }
    if (_canUseAndroidMessage()) {
        return PLATFORM.ANDROID;
    }
    return PLATFORM.WEB;
};

export const sendNativeMessage = (message: string, webCallback: () => void) => {
    switch (_getNativePlatform()) {
        case PLATFORM.IOS:
            return window.webkit.messageHandlers.ffi.postMessage(message);
        case PLATFORM.ANDROID:
            return window.android.postMessage(message);
        case PLATFORM.WEB:
        default:
            return webCallback();
    }
};
